import React, { useEffect } from "react";
import Hoc from "../../components/HOC";

export const NotFoundPage = () => {
  const token = localStorage.getItem("access_token");
  useEffect(() => {
    if (!token) {
      window.location.replace("/login");
    }
  }, [token]);

  if (!token) return null;

  const currentUrl = window.location.pathname;

  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className="grid place-content-center w-full bg-white px-4 min-h-screen">
      <div className="text-center">
        <h1 className="text-9xl font-black text-gray-200">404</h1>
        <p className="text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl mt-2">
          Oops! Page Not Found
        </p>
        <p className="mt-4 text-gray-500">
          The page <span className="font-mono bg-gray-100 px-2 py-1 rounded">{currentUrl}</span> does not exist.<br />
          You may have mistyped the address or the page may have moved.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8">
          <button
            onClick={handleBack}
            className="rounded bg-gray-300 px-5 py-3 text-sm font-medium text-gray-700 hover:bg-gray-400 focus:outline-none focus:ring"
          >
            Go Back
          </button>
          <a
            href="/"
            className="rounded bg-primary px-5 py-3 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring"
          >
            Go to Dashboard
          </a>
        </div>
      </div>
    </div>
  );
};

export default Hoc(NotFoundPage);